/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

function worker() {
  const DB_NAME = 'docsfordocumentary'
  const VERSION = 1

  let userId

  onmessage = function (e) {
    const type = e.data.type
    const data = e.data.payload

    switch (type) {
      case 'clearDB':
        clearDataBase(data)
        break

      case 'addToDB':
        saveToDB(data)
        break

      case 'SendToServer':
        sendToServer(data)
        break

      case 'sendFromDB':
        sendFromDB()
        break

      case 'GRANTED':
        console.log('Granted')
        saveToDB(data)
        break

      case 'CONNECTION_CHANGE':
        onStart(data)
        break

      case 'CANCEL':
        // пометим в БД все файлы из этого списка как CANCELED
        markAsCanceled(data)
        break

      default:
        break
    }
  }

  console.log('Worker BULK FILES started')

  // onStart()

  async function onStart(data) {
    if (data.status === 'IS_ONLINE') {
      userId = data.userId
      console.log('IS_ONLINE')
      const isExisting = (await indexedDB.databases())
        .map(db => db.name)
        .includes(DB_NAME)

      if (isExisting) {
        const noAccessRecords = await getNoAccessRecords(DB_NAME, VERSION)

        noAccessRecords.length > 0 &&
          postMessage({
            type: 'NEED_RESTART',
            payload: noAccessRecords,
            message:
              'Не все файлы были отправлены. Нажмите Restart чтобы завершить начатое',
          })
        // : postMessage({
        //     type: 'NEED_RESTART',
        //     payload: null,
        //     message: 'Все файлы отправлены',
        //   })
        sendFromDB()
      }
    }
  }

  // console.log("Initially " + (navigator.onLine ? "on" : "off") + "line");

  // navigator.onLine && sendFromDB();

  function saveToDB(data) {
    console.log('Saving to DB')
    const request = indexedDB.open(DB_NAME, VERSION)

    if (data.fileHandles.length === 0 && data.dirHandles.length === 0) return

    request.onsuccess = function (event) {
      const db = event.target.result

      console.log('DB is opened')

      const objectStoreFiles = db
        .transaction(['files'], 'readwrite')
        .objectStore('files')

      putMultiple(objectStoreFiles, data.fileHandles)
        .then(result => {
          // console.log("Файлы добавлены в хранилище", result);

          const objectStoreDirs = db
            .transaction(['dirhandles'], 'readwrite')
            .objectStore('dirhandles')

          putMultiple(objectStoreDirs, data.dirHandles)
            .then(result => {
              // console.log("Директория добавлена в хранилище", result);
              db.close()
              sendFromDB()
            })
            .catch(() => {
              db.close()
              console.log('Не удалось записать директорию в БД') //TODO - отправлять не из БД, а из массива, который пришёл?
            })
        })
        .catch(() => {
          db.close()
          console.log('Не удалось записать файлы в БД')
        })
    }

    request.onupgradeneeded = function (event) {
      const db = event.target.result

      console.log('onupgradeneeded')

      const objectStoreFiles = db.createObjectStore('files', { keyPath: 'id' })

      objectStoreFiles.createIndex('id', 'id', { unique: true })
      objectStoreFiles.createIndex('userId, sendStatus', [
        'userId',
        'sendStatus',
      ])
      objectStoreFiles.createIndex('dirHandleID', 'dirHandleID') //TODO добавить время

      const objectStoreDirs = db.createObjectStore('dirhandles', {
        keyPath: 'id',
      })

      objectStoreDirs.createIndex('id', 'id', { unique: true })

      saveToDB(data)
      db.close()
    }
  }

  function sendFromDB() {
    // getSize()
    const request = indexedDB.open(DB_NAME, VERSION)

    request.onsuccess = async function (event) {
      const db = event.target.result

      // console.log('DB is opened')

      const noAccessRecords = await getNoAccessRecords(DB_NAME, VERSION)

      noAccessRecords.length > 0 && requestPermissions(noAccessRecords)

      const objectStore = db
        .transaction(['files'], 'readwrite')
        .objectStore('files')

      const sendStatusIndex = objectStore.index('userId, sendStatus')

      sendStatusIndex.openCursor(
        IDBKeyRange.only([`${userId}`, `NOT_SENT`]),
      ).onsuccess = function (event) {
        var cursor = event.target.result

        if (cursor) {
          requestPost(cursor.value)
        } else {
          postMessage({
            type: 'FINISHED',
            payload: null,
            message: 'Все файлы отправлены',
          })
          // console.log('Все файлы отправлены')
        }
      }

      db.close()
    }
  }

  function requestPermissions(filesHandles) {
    const request = indexedDB.open(DB_NAME, VERSION)

    request.onsuccess = async function (event) {
      const db = event.target.result
      const dirHandlesIds = [
        ...new Set(filesHandles.map(item => item.dirHandleID)),
      ]

      const objectStoreDirHandles = db
        .transaction(['dirhandles'], 'readwrite')
        .objectStore('dirhandles')

      const dirHandlesIdIndex = objectStoreDirHandles.index('id')
      const dirHandles = await getMultiple(dirHandlesIdIndex, dirHandlesIds)

      postMessage({
        type: 'RequestPermissions',
        payload: { filesHandles, dirHandles },
      })
    }
  }

  // function deleteFromDB(key) { //TODO придет время и нужно будет удалять из базы
  //   const request = indexedDB.open(DB_NAME, VERSION)

  //   request.onsuccess = function (event) {
  //     const db = event.target.result

  //     console.log('DB is opened')
  //     const objectStore = db
  //       .transaction(['files'], 'readwrite')
  //       .objectStore('files')

  //     objectStore.delete(key)
  //   }
  // }

  function sendToServer(data) {
    // console.log('sendToServer')

    saveToDB(prepareForDB(data))
  }

  async function requestPost(data) {
    // console.log(
    //   await data.fileHandle.queryPermission({
    //     mode: 'read',
    //   }),
    // )

    postMessage({
      type: 'SendStatus',
      status: 'SENDING',
      payload: { id: data.id },
    })

    let file
    const dataSend = new FormData()

    try {
      file = await data.fileHandle.getFile()
    } catch (error) {
      postMessage({
        type: 'SendStatus',
        status: 'ERROR',
        payload: { id: data.id },
        message: `Can not read file ${data.fileHandle.name} ${error}`,
      })
      console.warn('Не могу прочитать файл: ', data.fileHandle.name)
      await changeRecordStatus(
        { sendStatus: 'NO_ACCESS', id: data.id },
        DB_NAME,
        VERSION,
      )
      sendFromDB()
      return
    }

    dataSend.append('document', file)

    try {
      if (
        data.endPoint === '/executivescheme' &&
        data.metaData.workingDrawing
      ) {
        const workingDrawingFile = await data.metaData.workingDrawing.getFile()

        data.metaData.workingDrawing = workingDrawingFile
      }
    } catch (error) {
      postMessage({
        type: 'SendStatus',
        status: 'ERROR',
        payload: { id: data.id },
        message: `Can not read file ${data.fileHandle.name} ${error}`,
      })
      console.warn('Не могу прочитать файл: ', data.fileHandle.name)
      await changeRecordStatus(
        { sendStatus: 'NO_ACCESS', id: data.id },
        DB_NAME,
        VERSION,
      )
      sendFromDB()
      return
    }
    if (data.endPoint === '/supporting') {
      dataSend.append(
        'supportingDto',
        new Blob(
          [
            JSON.stringify({
              description: data.metaData.description ?? null,
              issueDate: data.metaData.issueDate,
              name: data.metaData.name,
              number: data.metaData.number,
              organization: data.metaData.organization,
              projectId: data.projectId,
            }),
          ],
          {
            type: 'application/json',
          },
        ),
      )
    } else {
      dataSend.append('projectId', data.projectId)

      Object.keys(data.metaData).forEach(fieldName => {
        dataSend.append(fieldName, data.metaData[fieldName])
      })
    }

    fetch(`${this.location.origin}/filestore/api/v1${data.endPoint}`, {
      method: 'POST',
      // mode: 'cors',
      body: dataSend,
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    })
      .then(async response => {
        // console.log('status', response.status)
        if (response.status === 200) {
          postMessage({
            type: 'SendStatus',
            status: 'SUCCESS',
            payload: { id: data.id },
          })
          await changeRecordStatus(
            { sendStatus: 'SUCCESS', id: data.id },
            DB_NAME,
            VERSION,
          )
          return response.text()
        } else if (response.status === 409) {
          postMessage({
            type: 'SendStatus',
            status: 'CONFLICT',
            payload: { id: data.id },
          })
          await changeRecordStatus(
            { sendStatus: 'CONFLICT', id: data.id },
            DB_NAME,
            VERSION,
          )
        } else if (response.status === 400) {
          postMessage({
            type: 'SendStatus',
            status: 'BAD_REQUEST',
            payload: { id: data.id },
          })
          await changeRecordStatus(
            { sendStatus: 'BAD_REQUEST', id: data.id },
            DB_NAME,
            VERSION,
          )
        } else {
          postMessage({
            type: 'SendStatus',
            status: 'ERROR',
            payload: { id: data.id },
          })
          await changeRecordStatus(
            { sendStatus: 'FAILED', id: data.id },
            DB_NAME,
            VERSION,
          )
        }
      })
      // .then(text => {
      //   text && sendIds(text) //TODO Удалить, это для теста
      // })
      .catch(async err => {
        if (navigator.onLine) {
          postMessage({
            type: 'SendStatus',
            status: 'ERROR',
            payload: { id: data.id },
            message: `${data.fileHandle.name} ${err}`,
          })
          await changeRecordStatus(
            { sendStatus: 'FAILED', id: data.id },
            DB_NAME,
            VERSION,
          )
          sendFromDB()
        } else {
          postMessage({
            type: 'SendStatus',
            status: 'OFFLINE',
            payload: { id: data.id },
            message: `${data.fileHandle.name} ${err}`,
          })
        }
      })
      .finally(() => {
        navigator.onLine && sendFromDB()
        // setTimeout(() => {
        //   sendFromDB();
        // }, TIMEOUT);
      })
  }

  const changeRecordStatus = (data, DB_NAME, VERSION) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, VERSION)

      request.onsuccess = function (event) {
        const db = event.target.result
        const objectStore = db
          .transaction(['files'], 'readwrite')
          .objectStore('files')

        const indexID = objectStore.index('id')
        const record = indexID.get(data.id)

        record.onsuccess = event => {
          const record = event.target.result

          record.sendStatus = data.sendStatus
          const putRequest = objectStore.put(record)

          putRequest.onsuccess = ({ target: { result } }) => {
            resolve(result)
          }
          putRequest.onerror = ({ target: { error } }) => reject(error)
        }
      }
      request.onerror = ({ target: { error } }) => reject(error)
    })
  }

  const getMultiple = (store, keys) =>
    Promise.all(
      keys.map(
        key =>
          new Promise((resolve, reject) => {
            const request = store.get(key)

            request.onsuccess = ({ target: { result } }) => resolve(result)
            request.onerror = ({ target: { error } }) => reject(error)
          }),
      ),
    )

  const putMultiple = (store, array) =>
    Promise.all(
      array.map(
        value =>
          new Promise((resolve, reject) => {
            const request = store.put(value)

            request.onsuccess = ({ target: { result } }) => resolve(result)
            request.onerror = ({ target: { error } }) => reject(error)
          }),
      ),
    )

  const getPermissionsMultiple = array =>
    Promise.allSettled(
      array.map(value =>
        value.fileHandle.queryPermission({
          mode: 'read',
        }),
      ),
    )

  const changeRecordStatusMultiple = (array, sendStatus, DB_NAME, VERSION) =>
    Promise.all(
      array.map(value =>
        changeRecordStatus({ sendStatus, id: value.id }, DB_NAME, VERSION),
      ),
    )

  const clearDataBase = dbName => {
    console.log('Удаление базы данных')

    const request = indexedDB.deleteDatabase(dbName)

    request.onsuccess = function () {
      console.log('База данных удалена')
    }

    request.onerror = function (event) {
      console.log('Ошибка удаления базы данных', event.target.error)
    }
  }

  const prepareForDB = data => {
    //TODO добавить время
    const preparedData = {}
    const uniqDirHandleList = []

    userId = data.userId

    data.filesCollection.map(item => {
      !uniqDirHandleList.some(uniqItem => uniqItem.id === item.dirHandlerId) &&
        uniqDirHandleList.push({
          id: item.dirHandlerId,
          dirHandle: item.dirHandle,
        })
      return item
    })

    const filesCollection = data.filesCollection.map(item => {
      return { ...item, token: data.token }
    })

    preparedData.dirHandles = [...uniqDirHandleList]
    preparedData.fileHandles = [...filesCollection]

    return preparedData
  }

  const getNoAccessRecords = (DB_NAME, VERSION) => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, VERSION)

      request.onsuccess = function (event) {
        const db = event.target.result

        const objectStore = db
          .transaction(['files'], 'readwrite')
          .objectStore('files')

        const sendStatusIndex = objectStore.index('userId, sendStatus')
        const requestNOT_SENT = sendStatusIndex.getAll([
          `${userId}`,
          `NOT_SENT`,
        ])

        requestNOT_SENT.onsuccess = async function (values) {
          const objectStore = db
            .transaction(['files'], 'readwrite')
            .objectStore('files')
          const sendStatusIndex = objectStore.index('userId, sendStatus')

          const recordsNOT_SENT = values.target.result
          const noAccessRecords = []

          const requestNO_ACCESS = sendStatusIndex.getAll([
            `${userId}`,
            `NO_ACCESS`,
          ]) //TODO обработать файлы со статусом FAILED

          requestNO_ACCESS.onsuccess = async event => {
            const recordsNO_ACCESS = event.target.result
            const permissions = await getPermissionsMultiple(recordsNOT_SENT)
            const permissionsNO_ACCESS = await getPermissionsMultiple(
              recordsNO_ACCESS,
            )

            permissions.map(
              (item, index) =>
                item.status === 'fulfilled' &&
                item.value !== 'granted' &&
                noAccessRecords.push(recordsNOT_SENT[index]),
            )
            permissionsNO_ACCESS.map(
              (item, index) =>
                item.status === 'fulfilled' &&
                item.value !== 'granted' &&
                noAccessRecords.push(recordsNO_ACCESS[index]),
            )
            await changeRecordStatusMultiple(
              noAccessRecords,
              'NO_ACCESS',
              DB_NAME,
              VERSION,
            )
            resolve(noAccessRecords)
          }
        }
      }
    })
  }

  const markAsCanceled = async array => {
    await changeRecordStatusMultiple(array, 'CANCELED', DB_NAME, VERSION)
  }
}

export default worker
